// extracted by mini-css-extract-plugin
export var container = "_sa-0";
export var dotAnimation = "_sa-2";
export var dotsLoading = "_sa-1";